import { Component, OnInit, Inject, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { FeeService } from '../../../services/FeeService';
@Component({
  selector: 'app-fee-edit-dialog',
  templateUrl: './fee-edit-dialog.component.html',
  styleUrls: ['./fee-edit-dialog.component.css']
})
export class FeeEditDialogComponent implements OnInit {
  feeID: string;
  year: string;
  season: string;
  fieldID: string;
  semester: string;
  feeAmount: string;
  years = new Array();
  semesters = new Array();
  departments: any = {};
  constructor(public dialogRef: MatDialogRef<FeeEditDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private GL_MasterService: GL_MasterService, private FeeService: FeeService) {
    console.log(data);
    this.feeID = data.feeID;
    this.year = data.year;
    this.season = data.season;
    this.fieldID = data.fieldID;
    this.semester = data.semester;
    this.feeAmount = data["feeAmount"];
    console.log("FeeID --> " + this.feeID);
  }
  ngOnInit() {
    Array.from({ length: 30 }, (x, i) => this.years.push(i + 1380));
    Array.from({ length: 14 }, (x, i) => this.semesters.push(i + 1));
    this.GL_MasterService.getDepartments().subscribe(a => {
      this.departments = a;
      for (let i of a) {
        //console.log(i["departmentName_fa"] +" --- "+ this.fieldID);
        if (i["departmentName_fa"] == this.fieldID) {
          this.fieldID = i["departmentID"];
        }
      }
    });
  }
  onSubmit(f: NgForm) {
    this.FeeService.editFee(f.value).subscribe(f => {
      this.dialogRef.close({ event: 'close', data: "Done" });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/fee/fee-edit-dialog/fee-edit-dialog.component.ts